import styled from "styled-components";
import eror from "../../img/error.jpg";

const All = styled.div`
  width: 80vw;
  height: 100%;
  display: flex;
  @media screen and (max-width: 479px) {
    flex-direction: column;
    justify-content: center;
  }
`;
const Button = styled.div`
  text-align: center;
  font-weight: bold;
  font-size: 3vh;
  width: 20vw;

  height: 6vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #5b2632;
  cursor: pointer;
  border-radius: 2vh;
  transition: 0.3s;
  &:hover {
    transform: scale(1.2);
  }
  & > a {
    text-decoration: none;
  }
  @media screen and (max-width: 479px) {
    width: 100%;
    transform: scale(1.2);
    margin: 0;
    height: 4vh;
    font-size: 1.2rem;
    margin: 0;
  }
`;
const LP = styled.div`
  height: 100vh;
  width: 50vw;
  overflow: hidden;
  background-image: url(${(props) => props.zrodlo || eror});
  background-size: cover;
  background-position: 50%;

  & > img {
    height: 100%;
    width: auto;
  }
  @media screen and (max-width: 479px) {
    height: 40vh;
    width: 100%;
  }
`;
const PP = styled.div`
  height: 100vh;
  width: 35vw;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background-color: #333d1d;
  & > h1 {
    margin: 5vh;
    text-align: center;
    color: #f8ffe8;
    font-size: 10vh;
  }
  & > p {
    font-size: 1.5rem;
    text-align: center;
    margin: 5vh;
    color: #f8ffe8 !important;
  }
  & > a {
    margin-top: auto;
    color: #f8ffe8;
  }
  @media screen and (max-width: 479px) {
    height: auto;
    min-height: 50vh;
    width: 100%;
    & > h1 {
      font-size: 2.5rem;
      text-align: center;
      margin: 1vh 3vh;
      color: #f8ffe8;
    }
    & > a {
      margin: 0;
      width: 70%;
    }
    & > p {
      font-size: 1.5rem;
      text-align: justify;
      margin: 0 4vh;
    }
  }
`;

export { All, Button, LP, PP };
